import React from 'react';

export type IBreadcrumbs = {
  name: string;
  link: string;
};

export function Breadcrumbs({
  siteName = '',
  breadcrumbs = [],
}: {
  siteName: string;
  breadcrumbs: IBreadcrumbs[];
}) {
  const siteNamePrefix = siteName
    ? `${siteName} ${breadcrumbs.length > 0 ? '>' : ''} `
    : '';
  const breadCrumbsSuffix = breadcrumbs
    .map(({ name }, i) => (i === breadcrumbs.length - 1 ? name : `${name} > `))
    .join('');

  const fullBreadcrumbs = `${siteNamePrefix}${breadCrumbsSuffix}`;
  return <span>{fullBreadcrumbs}</span>;
}
